import { render, staticRenderFns } from "./gc-popup-shift-exception-downtime.vue?vue&type=template&id=637853e0"
import script from "./gc-popup-shift-exception-downtime.vue?vue&type=script&lang=js"
export * from "./gc-popup-shift-exception-downtime.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-shift-exception-downtime.vue?vue&type=style&index=0&id=637853e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports